import { useEffect, useRef } from "react";
import { tarneebInviteHomePath, tarneebRegistrationAgentRid, tarneebRegistrationPath,
  tarneebRoomGamePath, isTarneebRegisteredPlayer } from "./TarneebRoomInvite";

export function useTarneebRoomInvite({ location, history, getPersist, setPersist, getGameUrl, hallOrigin }) {
  const handled = useRef("");
  const loaded = getPersist("dataLoaded");
  const userInfo = getPersist("user_info");
  useEffect(() => {
    if (!loaded) return;
    if (location.pathname !== "/home" && location.pathname !== "/") {
      handled.current = "";
      return;
    }
    const query = new URLSearchParams(location.search);
    // Leave Tawla and Holdem invitations to their existing handlers.
    const returnPath = !query.has("aada_room_id") && !query.has("aada_subid") &&
      !query.has("holdem_room_id") && !query.has("holdem_subid") && tarneebInviteHomePath(query);
    if (!returnPath) {
      handled.current = "";
      return;
    }
    const registered = isTarneebRegisteredPlayer(userInfo);
    const key = `${registered ? "game" : "register"}:${returnPath}`;
    if (handled.current === key) return;
    handled.current = key;
    const incoming = new URLSearchParams(returnPath.split("?")[1]);
    setPersist("agent_rid", tarneebRegistrationAgentRid(returnPath, ""));
    setPersist("agent_from", incoming.get("f") || "");
    if (registered) {
      history.replace(tarneebRoomGamePath(location.search, getGameUrl(3), hallOrigin));
    } else {
      setPersist("isLogin", false);
      setPersist("login_back_url", returnPath);
      history.replace(tarneebRegistrationPath(returnPath));
    }
  }, [loaded, location.pathname, location.search, userInfo, getGameUrl, hallOrigin, history, setPersist]);
}
